'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  :hover:enabled {\n    background-color: ', ';\n  };\n  background: ', ';\n  background-size: 200%;\n  border-style: none;\n  border-radius: ', ';\n  * {\n    cursor: pointer;\n  }\n'], ['\n  :hover:enabled {\n    background-color: ', ';\n  };\n  background: ', ';\n  background-size: 200%;\n  border-style: none;\n  border-radius: ', ';\n  * {\n    cursor: pointer;\n  }\n']);

var _themeProps = require('@hixme-ui/theme-props');

var _ButtonBase = require('./ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GradientButton = _ButtonBase2.default.extend(_templateObject, function (props) {
  return (0, _themeProps.getButtonColor)(props).hover;
}, function (props) {
  return (0, _themeProps.getButtonColor)(props).default;
}, function (props) {
  return (0, _themeProps.getButtonBorderRadius)(props);
});

GradientButton.displayName = 'hui:GradientButton';
GradientButton.huiName = 'GradientButton';

exports.default = GradientButton;
//# sourceMappingURL=GradientButton.js.map


//////////////////
// WEBPACK FOOTER
// ../button/lib/GradientButton.js
// module id = 149
// module chunks = 0